<template>
  <div class="WarehousesTablePortal">
    <app-curtain-header
      title="Информация о складе"
      class="main-curtain-header"
    ></app-curtain-header>

    <div class="app-table-dropdown__portal main-curtain-body">
      <ul class="app-table-dropdown__list">
        <li class="app-table-dropdown__portal-list-item">
          <span
            class="WarehousesTablePortal__title app-table-dropdown__list-title"
          >
            Регион
          </span>
          <p class="app-table-dropdown__list-text">
            {{ response.region || 'н/д' }}
          </p>
        </li>
        <li class="app-table-dropdown__portal-list-item">
          <span
            class="WarehousesTablePortal__title app-table-dropdown__list-title"
          >
            Координаты
          </span>
          <p class="app-table-dropdown__list-text">
            {{ response.location || 'н/д' }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarehousesTablePortal',
  components: {
    AppCurtainHeader: () => import('@/components/common/AppCurtainHeader'),
  },
  props: {
    response: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.WarehousesTablePortal {
  &__title {
    min-width: 200px;
  }
}
</style>
